import { useEffect, useState } from 'react';
import {
  fetchVehiclesColors,
  VehiclesColorsMap,
} from 'shared/services/vehicles-colors.service';

export function useVehiclesColors() {
  const [colors, setColors] = useState<VehiclesColorsMap>({});
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    fetchVehiclesColors()
      .then((data) => {
        if (!cancelled) setColors(data);
      })
      .catch(() => {
        if (!cancelled) setColors({});
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const colorNames = Object.keys(colors);

  return { colors, colorNames, isLoading };
}
